import { descriptionPostValidator } from './descripton'
import { titlePostValidator } from './title'
import { urlPostValidator } from './url'
import { POST_KEY } from '../constants'

const postValidator = {
  [POST_KEY.TITLE]: titlePostValidator,
  [POST_KEY.DESCRIPTION]: descriptionPostValidator,
  [POST_KEY.URL]: urlPostValidator
}

export {
  postValidator
}
